import React, { Component } from "react";
import ApiConnect from "../../../Util/ApiConnect";

export default class CompanyList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Companies: [],
    };
  }
  componentDidMount() {
    this.fetchHandler();
  }
  fetchHandler() {
    ApiConnect.get("/NarayaniConcept/POS/Clients")
      .then((response) => {
        this.setState({ Companies: response.data });
      })
      .catch((error) => console.log(error));
    console.log(this.state.Companies);
  }
  render() {
    return (
      <div className="favorites">
        <div className="d-none">
          <div className="bg-primary border-bottom p-3 d-flex align-items-center">
            <a className="toggle togglew toggle-2" href="#">
              <span />
            </a>
            <h4 className="font-weight-bold m-0 text-white">NG POS Clients</h4>
          </div>
        </div>
        {/* Most popular */}
        <div className="container most_popular py-5">
          <h2 className="font-weight-bold mb-3">NG POS Clients</h2>
          <div className="row">
            {this.state.Companies &&
              this.state.Companies.map((comp, index) => (
                <div className="col-md-4 mb-3" key={index}>
                  <div className="list-card bg-white h-100 rounded overflow-hidden position-relative shadow-sm grid-card">
                    <div className="list-card-image text-center">
                      <a href={`POS/Menu/${comp.short}/${comp.id}`}>
                        <img
                          alt={comp.name}
                          src={comp.logo}
                          width={150}
                          className="img-fluid item-img"
                        />
                      </a>
                    </div>
                    <div className="p-3 position-relative">
                      <div className="list-card-body">
                        <h6 className="mb-1">
                          <a
                            href={`POS/Menu/${comp.short}/${comp.id}`}
                            className="text-black"
                          >
                            {comp.name}
                          </a>
                        </h6>
                        <p className="text-gray mb-3">{comp.address}</p>
                        <p className="text-gray mb-3 time">
                          <span className="bg-light text-dark rounded-sm pl-2 pb-1 pt-1 pr-2">
                            {comp.contact}
                          </span>{" "}
                          <span className="float-right text-black-50">
                            {comp.web}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    );
  }
}
